import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const FETCH = 'holidays/FETCH';
const FETCH_SUCCESS = 'holidays/FETCH_SUCCESS';
const FETCH_FAIL = 'holidays/FETCH_FAIL';

const initialState = {
  holidays: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        holidays: action.result.data
      };
    case FETCH_FAIL:
      return {
        ...state,
        error: action.error.data
      };
    default:
      return state;
  }
}

export function fetchHolidays(employeeID) {
  return {
    types: [FETCH, FETCH_SUCCESS, FETCH_FAIL],
    promise: client => client.get(`/harcirah/holidays?employeeID=${employeeID}`, {})
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/holidays.js